import { LoadingState } from "@app/root-store/api-result.state";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { User } from "../model/user";
import { UserRole } from "../model/user-role";

export interface UserManagementState {
    users: { result: ClareDbCollection<User>; callState: LoadingState };
    customers: { result: ClareDbCollection<User>; callState: LoadingState };
    activeEntityStaff: { result: User[]; entityId: number; callState: LoadingState };
    activeProjectUser: { result: User; callState: LoadingState };
    userRoles: { result: ClareDbCollection<UserRole>; callState: LoadingState };
    customerRoleId: number;
}

export const initialUserManagementState: UserManagementState = {
    users: { result: {}, callState: LoadingState.init },
    customers: { result: {}, callState: LoadingState.init },
    activeEntityStaff: { result: [], entityId: null, callState: LoadingState.init },
    activeProjectUser: { result: null, callState: LoadingState.init },
    userRoles: { result: null, callState: LoadingState.init },
    customerRoleId: null,
};
